/**
 * @generated SignedSource<<8b2f08c10bf46394e8716c368504c01e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteChildNodeButton_TreeNodeFragment$data = {
  readonly hasBeenPublishedOnce: boolean;
  readonly id: string;
  readonly rootId: string;
  readonly " $fragmentType": "DeleteChildNodeButton_TreeNodeFragment";
};
export type DeleteChildNodeButton_TreeNodeFragment$key = {
  readonly " $data"?: DeleteChildNodeButton_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteChildNodeButton_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteChildNodeButton_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBeenPublishedOnce",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootId",
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "09bdac1a95da99ea162dd5a7c8a1a3a9";

export default node;
